export type IProductNames =
  | 'passagem-aerea'
  | 'hospedagem'
  | 'pacote'
  | 'pacotecarro'
  | 'pacotecarro-oferecimento'
  | 'carro'
  | 'seguro';

// Se acrescentar um produto novo, insetir tambem no tipo IProductNames acima
export const PRODUCT_NAMES = {
  flight: 'passagem-aerea',
  hotel: 'hospedagem',
  package: 'pacote',
  packageCar: 'pacotecarro',
  packageCarOffer: 'pacotecarro-oferecimento',
  car: 'carro',
  insurance: 'seguro',
};

export const NameRouteBases = {
  recommend: 'recomenda',
  myAccount: 'minha-conta',
  myTravels: 'minhas-viagens',
  checkout: 'checkout',
  ...PRODUCT_NAMES,
};

export const RoutesBase = {
  recommend: {
    home: NameRouteBases.recommend,
    whoTravel: `${NameRouteBases.recommend}/onde-viajar`,
  },
  myAccount: {
    home: NameRouteBases.myAccount,
    informations: `${NameRouteBases.myAccount}/informacoes`,
  },
  myTravels: {
    list: NameRouteBases.myTravels,
    detail: `${NameRouteBases.myTravels}/detalhe-viagem`,
    payment: `${NameRouteBases.myTravels}/pagamento`,
  },
  flight: {
    home: NameRouteBases.flight,
    list: `${NameRouteBases.flight}/voos`,
  },
  hotel: {
    home: NameRouteBases.hotel,
    list: `${NameRouteBases.hotel}/hoteis`,
    detail: `${NameRouteBases.hotel}/hotel`,
    complete: {
      list: `${NameRouteBases.hotel}/completo`,
    },
  },
  package: {
    home: NameRouteBases.package,
    hotel: {
      list: `${NameRouteBases.package}/hoteis`,
      detail: `${NameRouteBases.package}/hotel`,
    },
    flight: {
      list: `${NameRouteBases.package}/voos`,
    },
    car: {
      list: `${NameRouteBases.package}/carros/pesquisa`,
      detail: `${NameRouteBases.package}/carros/detalhes`,
    },
    complete: {
      list: `${NameRouteBases.package}/hotel-voo/completo`,
      hotelCarro: `${NameRouteBases.package}/hotel-carro/completo`,
    },
  },
  packageCar: {
    hotel: {
      list: `${NameRouteBases.packageCar}/hoteis`,
      detail: `${NameRouteBases.packageCar}/hotel`,
    },
    flight: {
      list: `${NameRouteBases.packageCar}/voos`,
    },
    complete: {
      list: `${NameRouteBases.packageCar}/hotel-voo-carro/completo`,
    },
  },
  car: {
    home: NameRouteBases.car,
    list: `${NameRouteBases.car}/pesquisa`,
    detail: `${NameRouteBases.car}/detalhes`,
    complete: {
      list: `${NameRouteBases.car}/completo`,
    },
  },
  insurance: {
    home: NameRouteBases.insurance,
    list: `${NameRouteBases.insurance}/pesquisa`,
    detail: `${NameRouteBases.insurance}/detalhes`,
  },
  share: 'compartilhamento',
  checkout: `${NameRouteBases.checkout}`,
  checkoutFinalized: `${NameRouteBases.checkout}/fim`,
  paymentShared: 'pagamento-compartilhado',
  faq: 'faq',
  termsAndConditions: 'termos-e-condicoes-gerais-de-utilizacao',
  privacyPolicy: 'politica-de-privacidade',
  login: 'entrar',
  changePassword: 'redefinir-senha',
};
